import { ability as backend } from '@/api'
import { groupBy, last, find } from 'lodash'

export default {

  namespaced: true,

  state: {
    abilities: []
  },

  mutations: {
    setAbilities: (state, payload) => state.abilities = payload
  },

  actions: {
    loadUserAbilities: ({commit}) => new Promise((resolve, reject) => {
      backend.loadUserAbilities(response => {
        commit('setAbilities', response.data)
        resolve(resolve)
      }, error => reject(error))
    }), 
    loadTaskAbilities: ({commit}, taskId) => new Promise((resolve, reject) => {
      backend.loadTaskAbilities(taskId, response => {
        commit('setAbilities', response.data)
        resolve(resolve)
      }, error => reject(error))
    }),
    loadProjectAbilities: ({commit}, taskId) => new Promise((resolve, reject) => {
      backend.loadProjectAbilities(taskId, response => {
        commit('setAbilities', response.data)
        resolve(resolve)
      }, error => reject(error))
    }),
    hasPermission: ({state, getters}, payload) => new Promise((resolve, reject) => {
      console.log(payload.abilities)
      let hasAllAbilities = find(payload.abilities, ability => ability.name === '*')
      if(hasAllAbilities) {
        resolve()
        return
      }

      let hasAbility = state.abilities.filter(ability => {
        return ability.name === payload.action && ability.entity_type === payload.entityType
      }).length > 0
      if(hasAbility) {
        resolve()
      } else {
        reject('You do not have the required permissions to perform this action')
      }
    }),
    doesNotHavePermission: ({state}, payload) => new Promise((resolve, reject) => {
      let doesNotHavePermission = payload.abilities.filter(ability => {
        return ability.name === payload.action && ability.entity_type === payload.entityType
      }).length === 0
      if(doesNotHavePermission) {
        resolve('You do not have the required permissions to perform this action')
      } else {
        reject()
      }
    })
  },

  getters: {
    abilities: state => state.abilities,
    groupedAbilities: state => {
      return groupBy(state.abilities.map(ability => {
        ability.pivot.forbidden = !ability.pivot.forbidden
        ability.group_label = last(ability.entity_type.split('\\'))
        return ability
      }), 'group_label')
    }
  }
}
